import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { LocalStorage } from "src/app/services/local-storage";
import { Client } from "src/app/services/API/client";
import { toastrService } from "src/app/services/ux/toastr.service";
import { TranslateService } from "@ngx-translate/core";
@Component({
  templateUrl: "./transaction-progress.component.html",
  styleUrls: ["transaction-progress.css"]
})
export class TransactionProgressComponent implements OnInit {
  @ViewChild("description") descriptionDiv: ElementRef;
  @ViewChild("btnStatus") button: ElementRef;
  @ViewChild("tStatus") transactionstatus: ElementRef;

  currentParams: Params;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private ls: LocalStorage,
    private client: Client,
    private toastr: toastrService,
    private translateService: TranslateService
  ) {
    route.queryParams.subscribe((q) => (this.currentParams = q));
  }

  ngOnInit() {
    const serviceName = this.ls.get("sn");
    if (serviceName === null) {
      // * Ka ndodhur nje gabim
      this.toastr.error(this.translateService.instant("TransactionProgress.YouCannotMakePayments"));
      return;
    }
    if (this.currentParams["description"] === "invalid_credit_card") {
      this.transactionstatus.nativeElement.innerHTML = this.translateService.instant("TransactionProgress.WrongCreditCard")
      this.button.nativeElement.hidden = true;
    } else {
      this.descriptionDiv.nativeElement.value = this.currentParams[
        "description"
      ];

      this.client
        .post(`api/${serviceName}/finish-cc`, {
          transId: this.currentParams["transactionId"]
        })
        .then(() => {
          this.toastr.success(this.translateService.instant("TransactionProgress.PaymentIsMadeSuccessfully"));
          this.ls.destroy("sn");
          this.router.navigate(["/transaction-history"]);
        })
        .catch((error) => {
          if (error.error === "oshee_payment_failed") {
            this.toastr.error(this.translateService.instant("TransactionProgress.OSHEEPaymentFailed"));
          }
          if (error.error === "dogana_payment_failed") {
            this.toastr.error(this.translateService.instant("TransactionProgress.DOGANESPaymentFailed"));
          }
          if (error.error === "gjoba_payment_failed") {
            this.toastr.error(this.translateService.instant("TransactionProgress.GJOBESPaymentFailed"));
          }
          if (error.error === "ukmun_payment_failed") {
            this.toastr.error(this.translateService.instant("TransactionProgress.UjesjellesitPaymentFailed"));
          }
          if (error.error === "ukd_payment_failed") {
            this.toastr.error(this.translateService.instant("TransactionProgress.UjesjellesitPaymentFailed"));
          }

          this.ls.destroy("sn");
          this.router.navigate(["/transaction-history"]);
        });
    }
  }
}
